module.exports = __webpack_public_path__ + "tenant-manage.043e657a9bf26f9ab73f8a87a1c00dbc.hashedasset.svg";